import { store } from '@wajeez-web/stores/base';
import { ContentEntityTypeNavigationsActions } from '@wajeez-web/stores/content';
import { Server } from '@wajeez/wajeez.microservices';
import { handleDispatchResult } from '@wajeez-web/core/utils';

export const getContentEntityTypeNavigationsDataTable = async (
  data: Server.ContentEntityTypeNavigationDatatable,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    ContentEntityTypeNavigationsActions.getContentEntityTypeNavigationsDataTableAsync(
      data
    )
  );

  return handleDispatchResult(res, onSuccess);
};

export const getContentEntityTypeNavigationById = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    ContentEntityTypeNavigationsActions.getContentEntityTypeNavigationByIdAsync(
      id
    )
  );

  return handleDispatchResult(res, onSuccess);
};

export const clearContentEntityTypeNavigationById = async () => {
  store.dispatch(
    ContentEntityTypeNavigationsActions.clearContentEntityTypeNavigationById()
  );
};

export const createContentEntityTypeNavigation = async (
  data: Server.CreateContentEntityTypeNavigationInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    ContentEntityTypeNavigationsActions.createContentEntityTypeNavigationAsync(
      data
    )
  );

  return handleDispatchResult(res, onSuccess);
};

export const editContentEntityTypeNavigation = async (
  data: Server.UpdateContentEntityTypeNavigationInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    ContentEntityTypeNavigationsActions.editContentEntityTypeNavigationAsync(
      data
    )
  );

  return handleDispatchResult(res, onSuccess);
};
